export default "__VITE_ASSET__CwOtPqbZ__"